export const AITagCategory = {
  PAIN_POINT: 'pain_point',
  EMOTIONAL_GAIN: 'emotional_gain',
  TARGET_PERSONA: 'target_persona',
  BUYING_MOTIVE: 'buying_motive',
  USAGE_SCENE: 'usage_scene',
  PURCHASE_INTENT: 'purchase_intent',
  FEATURE: 'feature',
  PRODUCT_STRENGTH: 'product_strength',
  MATERIAL: 'material',
  SEASON: 'season',
  OCCASION: 'occasion'
} as const

export type AITagCategory = (typeof AITagCategory)[keyof typeof AITagCategory]

export interface AITagMaster {
  id: number
  site_id: number
  tag_name: string
  tag_category: AITagCategory
  tag_category_label: string
  importance_score: number
  occurrence_count: number
  product_count: number
  feature_count: number
  created_at: string | null
  updated_at: string | null
}

export interface AITagMapping {
  id: number
  site_id: number
  ai_tag_id: number
  source_type: string
  source_id: string
  source_name: string
  confidence_score: number
  created_at: string
}

export interface TagUpdateRequest {
  status?: string | null
  tag_name?: string | null
  tag_category?: AITagCategory | null
  importance_score?: number | null
}

export interface EffectivenessTag {
  id: number
  tag_name: string
  tag_category: AITagCategory
  product_count: number
  views_30d: number
  clicks_30d: number
  purchases_30d: number
  cvr: number
  ctr: number
  effectiveness_score: number
}

export interface AnalysisProgress {
  status: string
  total: number
  processed: number
  tags_found: number
  message: string
}

export interface TagGeneration {
  id: number
  summary: string
  tag_count: number
  created_at: string | null
}

export interface TagGenerationCurrent {
  tag_count: number
  mapping_count: number
  analyzed_at: string | null
}

export interface PreviewProduct {
  id: string | number
  name: string
  image_url: string | null
  price: number | null
  category: AITagCategory | null
}
